import { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import UserPasskeyInformation from  '@/components/page/OrgSettings/Users/UserPasskeyInformation/UserPasskeyInformation';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';
import { GrantTypeService } from '@/services/grantType.service';



const UserPasskeysInformationPortal = () => {    
    const { setOrgId } = useContext(OrgSettingsContext);
    const { setUserId } = useContext(OrgSettingsUsersContext);

    const targetContainer = document.getElementById('react-user-passkeys-information');
    const orgId = targetContainer?.dataset.orgId
    const userId = targetContainer?.dataset.userId;

    if(!targetContainer) {
        return null;
    } else if (orgId && userId){
        setOrgId(orgId)
        setUserId(userId)
        
        GrantTypeService.initGrantTypeService({
               isMfa: targetContainer?.dataset.isMfaSession=== 'True',
               isExternalLogin: targetContainer?.dataset.isExternalLogin === 'True'
        })
        
       
    }

    return ReactDOM.createPortal(
        <UserPasskeyInformation />, targetContainer
    );
}


export default UserPasskeysInformationPortal;